import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "@emotion/react/jsx-runtime";
import { css } from '@emotion/react';
import { ChipsIconElement } from '../icons/chipsIconElement';
import { JacksIconElement } from '../icons/jacksIconElement';
import { assertUnreachable } from '../utils/tsUtils';
function getIcon(type) {
    if (!type) {
        return null;
    }
    switch (type) {
        case 'chips': {
            return _jsx(ChipsIconElement, {});
        }
        case 'jacks': {
            return _jsx(JacksIconElement, {});
        }
        default: {
            assertUnreachable(type);
        }
    }
}
export const ValueDisplay = ({ isLabelFirst, label, value, type, title }) => {
    const valueString = typeof value === 'string' ? value : value.toLocaleString();
    const prefix = type === 'chips' ? '$' : '';
    const getAriaLabel = () => (isLabelFirst ? `${label}: ${prefix}${valueString}` : `${prefix}${valueString} ${label}`);
    // always render at least 'aria-label' or 'title', giving priority to any provided title:
    const ariaLabel = !title ? getAriaLabel() : undefined;
    const containerProps = {
        ...(title ? { title } : {}),
        ...(ariaLabel ? { 'aria-label': ariaLabel } : {})
    };
    return (_jsx("span", { ...containerProps, children: isLabelFirst ? (_jsxs(_Fragment, { children: [getIcon(type), _jsxs("span", { children: [label, ":"] }), ' ', _jsxs("span", { css: css `
              margin-left: 5px;
            `, children: [prefix, valueString] })] })) : (_jsxs(_Fragment, { children: [getIcon(type), prefix, valueString, " ", label] })) }));
};
